export default __webpack_public_path__ + "static/media/hyderabad.9c548900.webp";